import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  inline-size: 100%;
  padding-block-start: 12px;
  border-block-start: 1px #000000 solid;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  justify-content: flex-start;
  align-items: flex-start;

  ${theme.breakpoints.up("tablet")} {
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

const titleStyle = `
  color: rgba(0, 0, 0, 0.8);
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
`;

export const Title = styled.div`
  flex-shrink: 0;

  ${titleStyle}
  font-family: ${fontRobotoCondensed};
`;

export const TitleLink = styled(EntityLink)`
  flex-shrink: 0;

  ${titleStyle}
  font-family: ${fontRobotoCondensed};
`;

export const Dash = styled.span`
  margin-inline: 16px 8px;

  color: #000000;

  ${theme.breakpoints.only("mobile")} {
    display: none;
  }
`;

export const Description = styled.div`
  color: #5a5a5a;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: normal;
`;
